import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "lock-1" }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M5.25,24C4.009,24,3,22.991,3,21.75v-10.5C3,10.009,4.009,9,5.25,9H6V6c0-3.308,2.692-6,6-6c3.308,0,6,2.692,6,6v3h0.75 C19.991,9,21,10.009,21,11.25v10.5c0,1.241-1.009,2.25-2.25,2.25H5.25z M5.25,10.5c-0.414,0-0.75,0.336-0.75,0.75v10.5 c0,0.414,0.336,0.75,0.75,0.75h13.5c0.414,0,0.75-0.336,0.75-0.75v-10.5c0-0.414-0.336-0.75-0.75-0.75H5.25z M16.5,9V6 c0-2.481-2.019-4.5-4.5-4.5C9.519,1.5,7.5,3.519,7.5,6v3H16.5z" }), /* @__PURE__ */ _jsx("path", { d: "M12,18.75c-0.414,0-0.75-0.336-0.75-0.75v-3c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v3 C12.75,18.414,12.414,18.75,12,18.75z" })] })]
});
export default SvgLock1;
